import { render, staticRenderFns } from "./TranslationLinks.vue?vue&type=template&id=a0ce4bb2&scoped=true&"
import script from "./TranslationLinks.vue?vue&type=script&lang=js&"
export * from "./TranslationLinks.vue?vue&type=script&lang=js&"
import style0 from "./TranslationLinks.vue?vue&type=style&index=0&id=a0ce4bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ce4bb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0ce4bb2')) {
      api.createRecord('a0ce4bb2', component.options)
    } else {
      api.reload('a0ce4bb2', component.options)
    }
    module.hot.accept("./TranslationLinks.vue?vue&type=template&id=a0ce4bb2&scoped=true&", function () {
      api.rerender('a0ce4bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/TranslationLinks.vue"
export default component.exports